import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
Alpine.plugin(collapse);
window.Alpine = Alpine;

import Cookies from 'js-cookie';

import Marquee3k from 'marquee3000';

import body from './blocks/body';
import quickNav from './blocks/quick-nav';
import exitPopup from './components/exit-popup';
import podcastTicker from './components/podcast-ticker';
import blogInsights from './components/blog-insights';
import expandableContent from './components/expandable-content';
import { verticalSlider } from './blocks/vertical-slider';
import { coverflowSlider } from './blocks/coverflow-slider';
import { tallSlider } from './blocks/tall-slider';
import { cardCarousel } from './blocks/card-carousel';
import { singleTabbedSlider } from './blocks/single-tabbed-slider';
import { testimonialCarousel } from './blocks/testimonial-carousel';
import { imageTextCarousel } from './blocks/image-text-carousel';
import { threeCardCarousel } from './blocks/3-card-carousel';
import { timeline } from './blocks/timeline';
import { teamCarousel } from './blocks/team';
import { statsPods } from './blocks/stats-pads';
import { postList } from './libs/post-list';
import teamModal from './blocks/teamModal';
import ctaWebinar from './blocks/ctaWebinar';
import { multiTabbedContent } from './blocks/multi-tabbed-content';
import { multiTabbedContentButtons } from './blocks/multi-tabbed-content-w-button';
import { blogList } from './blocks/blog-list';
import videoModal from './blocks/videoModal';
import employeeModal from './blocks/employeeModal';
import { brochureCarousel } from './blocks/cta-brochure-carousel';
import { brandLogoCarousel } from './blocks/brand-logo-carousel';
import { slimLineBrandLogoCarousel } from './blocks/slim-line-brand-logos';
import joinOurTeam from './blocks/joinOurTeam';
import glossary from './blocks/glossary';
import { carouselRequestDemo } from './blocks/carousel-request-demo';
import {keyContent} from './blocks/key-content';

const axios = require('axios');

document.addEventListener('alpine:init', () => {
  Alpine.data('body', body);
  Alpine.data('quickNav', quickNav);
  Alpine.data('exitPopup', exitPopup);
  Alpine.data('podcastTicker', podcastTicker);
  Alpine.data('teamModal', teamModal);
  Alpine.data('videoModal', videoModal);
  Alpine.data('employeeModal', employeeModal);
  Alpine.data('ctaWebinar', ctaWebinar);
  Alpine.data('glossary', glossary);
  Alpine.data('joinOurTeam', joinOurTeam);
  Alpine.data('blogInsights', blogInsights);
  Alpine.data('expandableContent', expandableContent);

  Alpine.data('applyModal', () => ({
    open: false,
    init() {
      let applies = document.querySelectorAll('.is-style-apply a');
      [...applies].forEach((v, i, a) => {
        v.addEventListener('click', (e) => {
          e.preventDefault();
          this.toggle();
          return false;
        });
      });

      this.$watch('open', (v, vo) => {
        if (v) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      });
    },
    toggle() {
      this.open = !this.open;
    },
  }));

  Alpine.data('newsletterPopup', (timeout, expireTime) => ({
    open: false,
    init() {
      let exitEnabled = document.body.classList.contains('exit-enabled');
      if (
        typeof Cookies.get('newsletter-popup') === 'undefined' &&
        !exitEnabled
      ) {
        setTimeout(() => {
          exitEnabled = document.body.classList.contains('exit-enabled');
          if (!exitEnabled) {
            this.open = true;
            Cookies.set('newsletter-popup', 'popped', {
              expires: expireTime,
            });
          }
        }, timeout * 1000);
      }

      this.$watch('open', (v, vo) => {
        if (v) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      });
    },
  }));

  Alpine.data('brochureModal', () => ({
    open: false,
    init() {
      this.$watch('open', (v, vo) => {
        if (v) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      });
    },
  }));

  Alpine.data('ctaModal', () => ({
    open: false,
    init() {
      this.$watch('open', (v, vo) => {
        if (v) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      });
    },
  }));

  Alpine.data('headerModal', () => ({
    open: false,
    type: 'book',
    init() {
      this.$watch('open', (v, vo) => {
        if (v) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      });
    },
  }));
});
Alpine.start();

document.addEventListener('DOMContentLoaded', function () {
  /** Init blocks **/
  verticalSlider();
  coverflowSlider();
  tallSlider();
  cardCarousel();
  singleTabbedSlider();
  testimonialCarousel();
  imageTextCarousel();
  threeCardCarousel();
  timeline();
  teamCarousel();
  postList();
  brochureCarousel();
  statsPods();
  multiTabbedContent();
  multiTabbedContentButtons();
  blogList();
  brandLogoCarousel();
  slimLineBrandLogoCarousel();
  glossary();
  carouselRequestDemo();
  keyContent();

  let openChats = document.querySelectorAll('a[href="#openchat"]');
  [...openChats].forEach(function (v, i, a) {
    v.addEventListener('click', function (e) {
      e.preventDefault();
      let chat = document.querySelector("[id^='max_chat_start']");
      chat.click();
      return false;
    });
  });

  Marquee3k.init();
});

/*
MIT License

Copyright (c) 2019 Jacob Filipp

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/

/** Lazy load videos
 * Ref - https://web.dev/lazy-loading-video/
 */
document.addEventListener('DOMContentLoaded', function () {
  var lazyVideos = [].slice.call(document.querySelectorAll('video.lazy'));

  if ('IntersectionObserver' in window) {
    var lazyVideoObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (
              typeof videoSource.tagName === 'string' &&
              videoSource.tagName === 'SOURCE'
            ) {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove('lazy');
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});
